main.utils = {

    /**
     * main.utils.hasClass() returns a boolean
     * based on the element passed-in element existence in the DOM
     */
    hasClass: function (el, className) {
        if (el.classList)
            return el.classList.contains(className);
        else
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    },

    /**
     * main.utils.addClass() adds a classname
     * to the passed-in in element
     */
    addClass: function (el, className) {
        if (el.classList)
            el.classList.add(className);
        else if (!main.utils.hasClass(el, className))
            el.className += ' ' + className;
    },

    /**
     * main.utils.removeClass() removes a classname
     * from the passed-in in element
     */
    removeClass: function (el, className) {
        if (el.classList)
            el.classList.remove(className);
        else if (main.utils.hasClass(el, className)) {
            var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
            el.className = el.className.replace(reg, ' ');
        }
    },

    /**
     * main.utils.addClass() toggles a classname
     * from the passed-in in element
     */
    toggleClass: function (el, className) {
        if (el.classList) {
            el.classList.toggle(className);
        } else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)
                classes.splice(existingIndex, 1);
            else
                classes.push(className);

            el.className = classes.join(' ');
        }
    },

    /**
     * main.utils.createCookie() sets a browser cookie
     * @param name: Identifier for the cookie
     * @param value: Boolean, String value etc
     * @param days: Time until expiration
     */
    createCookie: function (name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }
        else expires = '';
        document.cookie = name + '=' + value + expires + '; path=/';
    },

    /**
     * main.utils.readCookie() returns a browser cookie value
     * @param name
     */
    readCookie: function (name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    /**
     * main.utils.eraseCookie() erase a browser cookie id & value
     * @param name
     */
    eraseCookie: function (name) {
        main.utils.createCookie(name, '', -1);
    },

    /**
     * main.utils.debounce() reduce frequency of triggering a function
     */
    debounce: function (func, wait, immediate) {
        var timeout;

        return function () {
            var context = this;
            var args = arguments;
            var callNow = immediate && !timeout;

            function later() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            }

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    },

    /**
     * main.utils.viewport() return an object with the viewport width & height
     * usage eg. main.utils.viewport().width
     * @return {{width, height}}
     */
    viewport: function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }

        return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    },

    loadScript: function(url) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.body.appendChild(script);
    },

    extend: function(target) {

        target = Object(target);

        var argLen = arguments.length;
        var source, key;

        for (var i = 1; i < argLen; i++) {
            source = arguments[i];
            if (source !== null) {
                for (key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }

        return target;
    },

    isIE: function() {
        return /Edge\/|Trident\/|MSIE /.test(window.navigator.userAgent);
    }
};
